import React from "react";
import { useTranslation } from "react-i18next";

const AboutSection = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="about section light-background">
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row align-items-xl-center gy-5">
          <div className="col-xl-5 content">
            <h3 className="text-success">{t("about.titleTag")}</h3>
            <h2 className="mb-4">{t("about.title")}</h2>
            <p className="mb-3">{t("about.description1")}</p>
            <p className="mb-3">{t("about.description2")}</p>
            <div className="alert alert-success p-3 rounded shadow-sm">
              <strong>{t("about.bonusTitle")}</strong> {t("about.bonusContent")}
            </div>
            <a href="#contact" className="read-more mt-4 d-inline-block">
              <span>{t("about.cta")}</span>
              <i className="bi bi-arrow-right"></i>
            </a>
          </div>

          <div className="col-xl-7">
            <div className="row gy-4 icon-boxes">
              <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                <div className="icon-box shadow-lg p-4 rounded">
                  <i className="bi bi-calendar-check"></i>
                  <h3>{t("about.cards.digital.title")}</h3>
                  <p>{t("about.cards.digital.desc")}</p>
                </div>
              </div>

              <div className="col-md-6" data-aos="fade-up" data-aos-delay="300">
                <div className="icon-box shadow-lg p-4 rounded">
                  <i className="bi bi-bar-chart"></i>
                  <h3>{t("about.cards.transparency.title")}</h3>
                  <p>{t("about.cards.transparency.desc")}</p>
                </div>
              </div>

              <div className="col-md-6" data-aos="fade-up" data-aos-delay="400">
                <div className="icon-box shadow-lg p-4 rounded">
                  <i className="bi bi-people"></i>
                  <h3>{t("about.cards.community.title")}</h3>
                  <p>{t("about.cards.community.desc")}</p>
                </div>
              </div>

              <div className="col-md-6" data-aos="fade-up" data-aos-delay="500">
                <div className="icon-box shadow-lg p-4 rounded">
                  <i className="bi bi-lightbulb"></i>
                  <h3>{t("about.cards.ai.title")}</h3>
                  <p>{t("about.cards.ai.desc")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
